module.exports = __webpack_public_path__ + "static/img/sy6.a570ceee.png";